export enum Reducers {
  // Entities
  ACTS = 'acts',
  AFFILIATES = 'affiliates',
  BEACONS = 'beacons',
  CATEGORIES = 'categories',
  DOCUMENTS = 'documents',
  EMAIL_TEMPLATES = 'emailTemplates',
  FEEDBACK = 'feedback',
  HYPERWALLET_ACCOUNTS = 'hyperwalletAccounts',
  HYPERWALLET_LOGS = 'hyperwalletLogs',
  INVITATIONS = 'invitations',
  LINKS = 'links',
  MESSAGES = 'messages',
  NOTIFICATIONS = 'notifications',
  PAYOUTS = 'payouts',
  PRODUCTS = 'products',
  PROFILES = 'profiles',
  REQUESTS = 'requests',
  REVIEWS = 'reviews',
  SHOWS = 'shows',
  THREADS = 'threads',
  TICKETS = 'tickets',
  TYPING_STATES = 'typingStates',
  USERS = 'users',
  VENUES = 'venues',

  // Features
  FORMS = 'forms',
  HOME = 'home',
  MAP = 'map',
  SEARCH = 'search',
  SETTLEMENT = 'settlement',
  STRIPE = 'stripe',
  UPLOADS = 'uploads',

  // Helpers
  HELPERS = 'helpers',
  ROUTER = 'router',
  SESSION = 'session',
}
